import { Host, h } from "@stencil/core";
import { formMessageLogic } from "../../common/form";
import { formClasses } from "../../common/classesNames";
import { commonClassesNames } from "../../common/classesNames";
import { repositionScroll } from "../../common/reposition-scroll";
import state from "../store";
export class GxgListBox {
    constructor() {
        this.theTitle = undefined;
        this.checkboxes = false;
        this.singleSelection = false;
        this.allowsEmpty = false;
        this.emitEmptySelection = false;
        this.keyboardSuggestions = {
            checkCheckbox: "to check a checkbox press (shift + space)",
            uncheckCheckbox: "to uncheck a checkbox press (shift + ctrl + space)"
        };
        this.disableSuggestions = false;
        this.noBorder = false;
        this.borderTop = false;
        this.borderEnd = false;
        this.borderBottom = false;
        this.borderStart = false;
        this.selectedItems = [];
        this.checkedItems = [];
        this.hideKeyboardSuggestions = true;
        this.headerHeight = 0;
        this.disabled = false;
        this.required = false;
        this.validationStatus = "indeterminate";
        this.validationMessage = undefined;
        this.informationMessage = undefined;
    }
    /**
     * This event emits the items that are currently selected. event.detail contains the selected items as objects. Each object contains the item idex and the item value. If value was not provided, the value will be the item innerText.
     */
    selectionChanged;
    checkedChanged;
    el;
    header;
    main;
    containerEl;
    /**
     * This is needed to evaluate if keyboard suggestions should be displayed.
     */
    userUsedKeyboard = false;
    activeItem;
    selectedItemsState = [];
    /*VALIDATION*/
    formMessageLogic = formMessageLogic;
    /*********************************
    METHODS
    *********************************/
    async getSelectedItems() {
        const selectedItems = this.getSelectedItemsFunc();
        const selectedItemsInformation = [];
        selectedItems.forEach(selectedItem => {
            selectedItemsInformation.push({
                active: selectedItem.active,
                selected: selectedItem.selected,
                checked: selectedItem.checked,
                index: selectedItem.index,
                value: selectedItem.value || selectedItem.textContent
            });
        });
        return selectedItemsInformation;
    }
    componentDidRender() {
        if (this.theTitle) {
            this.headerHeight = this.header.clientHeight;
        }
    }
    componentDidLoad() {
        //this.setInitialActive();
    }
    setIndexes = () => {
        const allItems = this.getAllItems();
        allItems.forEach((item, i) => {
            item.index = i;
        });
    };
    initialSetup = () => {
        const enabledItems = this.getEnabledItems();
        const selectedItemsLength = this.selectedItemsLength();
        //1. Select item if allowsEmpty is false and no item is currently selected
        const selectItem = !this.allowsEmpty && selectedItemsLength === 0;
        if (selectItem) {
            const firstDeselectedItem = enabledItems.find(item => {
                return !item.selected;
            });
            firstDeselectedItem && (firstDeselectedItem.selected = true);
        }
        else if (this.singleSelection && selectedItemsLength > 1) {
            //Only one item can be selected. Unselect every selected items, except the first one.
            const selectedItems = this.getSelectedItemsFunc();
            selectedItems.forEach((selectedItem, i) => {
                if (i !== 0) {
                    selectedItem.selected = false;
                }
            });
        }
        //2. Set active item, if not active item exists yet
        const currentActiveItem = this.getActiveItem();
        if (!currentActiveItem) {
            const firstEnabledItem = this.getEnabledItems()[0];
            if (firstEnabledItem) {
                firstEnabledItem.active = true;
                this.activeItem = firstEnabledItem;
            }
        }
        //3. Set index on every item
        this.setIndexes();
        //4. disable items
        if (this.disabled) {
            this.disabledHandler(true);
        }
        //5. set checkboxes
        if (this.checkboxes) {
            const allItems = this.getAllItems();
            allItems.forEach(item => {
                item.checkbox = true;
            });
        }
    };
    itemLoadedHandler() {
        this.initialSetup();
        this.updateSelectedItems();
    }
    itemClickedHandler(event) {
        const { clickedItem, ctrlKey, cmdKey, shiftKey, index } = event["detail"];
        if (this.singleSelection) {
            this.setActiveItem(clickedItem);
        }
        this.containerEl.focus();
        //this.clearActiveItem();
        if (this.singleSelection) {
            if (clickedItem.selected &&
                !this.allowsEmpty) {
                /*same item. do nothing.*/
                return;
            }
            if (this.allowsEmpty && (ctrlKey || cmdKey)) {
                this.unselectItems(clickedItem);
            }
            else {
                this.clearHighlightedItems();
                this.clearSelectedItems();
                this.selectItems(clickedItem);
                this.highlightItem(clickedItem);
            }
        }
        else {
            /*multiple-selection allowed*/
            if (shiftKey || (!cmdKey && !cmdKey)) {
                this.clearHighlightedItems();
                this.clearSelectedItems();
            }
            if (shiftKey) {
                if (this.activeItem === clickedItem)
                    return;
                let fromIndex;
                const toIndex = index;
                if (this.activeItem) {
                    const activeItemIndex = this.getIndexByElement(this.activeItem);
                    if (index === activeItemIndex) {
                        return;
                    }
                    fromIndex = activeItemIndex;
                }
                else {
                    fromIndex = 0;
                }
                this.selectMultipleItems(fromIndex, toIndex);
            }
            else if (ctrlKey || cmdKey) {
                if (!this.allowsEmpty &&
                    this.selectedItemsLength() === 1 &&
                    clickedItem.selected) {
                    return;
                }
                this.unhighlightItem(this.activeItem);
                this.toggleItem(clickedItem);
                this.highlightItem(clickedItem);
            }
            else {
                this.selectItems(clickedItem);
                this.highlightItem(clickedItem);
            }
        }
        this.setActiveItem(clickedItem);
        this.evaluateSelectedItems();
    }
    selectedItemsHandler(newArray) {
        this.selectionChanged.emit({ items: newArray });
    }
    checkedItemsHandler(newArray) {
        this.checkedChanged.emit(newArray);
    }
    disabledHandler(disabled) {
        if (disabled) {
            const enabledItems = this.getEnabledItems();
            enabledItems?.forEach(item => {
                item.disabled = true;
            });
        }
        else {
            const disabledItems = this.getDisabledItems();
            disabledItems?.forEach(item => {
                item.disabled = false;
            });
        }
    }
    hideKeyboardSuggestionsHandler(newValue, oldValue) {
        newValue === true &&
            oldValue === false &&
            localStorage.setItem("gxg-list-box-hide-keyboard-suggestions", "true");
    }
    itemSelectedHandler() {
        this.setSiblingSelected();
    }
    checkboxStateChangedHandler(e) {
        const checkedItemEl = e.detail.checkedItem;
        const checkedItemValue = e.detail.checked;
        /*Update checkboxes array*/
        const checkedItemsArray = [];
        const enabledItems = this.getEnabledItems();
        if (enabledItems?.length) {
            enabledItems.forEach(enabledItem => {
                let item;
                if (enabledItem === checkedItemEl) {
                    item = checkedItemEl;
                }
                else {
                    item = enabledItem;
                }
                const checked = enabledItem === checkedItemEl ? checkedItemValue : item.checked;
                if (item && checked) {
                    checkedItemsArray.push({
                        active: item.active,
                        selected: item.selected,
                        checked: checked,
                        index: item.index,
                        value: item.value || item.textContent
                    });
                }
            });
            this.checkedItems = checkedItemsArray;
        }
        /*Local Storage*/
        const localStorageExists = localStorage.getItem("gxg-list-box-hide-keyboard-suggestions");
        if (!localStorageExists &&
            !this.disableSuggestions &&
            this.userUsedKeyboard) {
            this.hideKeyboardSuggestions = false;
        }
    }
    handleKeyDown = (e) => {
        this.userUsedKeyboard = true;
        const ctrlKey = e.ctrlKey;
        const cmdKey = e.metaKey;
        const shiftKey = e.shiftKey;
        //const activeItemIndex = this.getIndexByElement(this.activeItem);
        if (e.code === "ArrowDown" ||
            e.code === "ArrowUp" ||
            e.code === "Space" ||
            e.code === "Backspace" ||
            e.code === "Delete" ||
            e.code === "KeyA") {
            e.preventDefault();
        }
        if (e.code === "ArrowDown" || e.code === "ArrowUp") {
            this.handleArrow(e.code, shiftKey);
        }
        else if (e.code === "Space") {
            if (shiftKey && ctrlKey) {
                /*uncheck checkbox*/
                const changedLength = this.setCheckboxState(this.getHighlightedItems(), false);
                changedLength > 0 && (this.hideKeyboardSuggestions = true);
            }
            else if (shiftKey && (!ctrlKey || !cmdKey)) {
                const changedLength = this.setCheckboxState(this.getHighlightedItems(), true);
                changedLength > 0 && (this.hideKeyboardSuggestions = true);
            }
            else if (!shiftKey &&
                (ctrlKey || cmdKey) &&
                this.selectedItemsLength() >= 1) {
                this.unselectHighlightedItems();
            }
            else if (!ctrlKey && !cmdKey) {
                if (this.singleSelection) {
                    if (this.activeItem === this.getSelectedItemsFunc()[0]) {
                        return;
                    }
                    this.clearSelectedItems();
                    this.selectItems(this.activeItem);
                }
                else {
                    /*multi-select allowed*/
                    if (ctrlKey || cmdKey) {
                        this.clearHighlightedItems();
                    }
                    else {
                        this.selectItems(this.activeItem);
                        //this.selectHighlightedItems();
                    }
                }
            }
        }
        else if (e.code === "KeyA" &&
            (ctrlKey || cmdKey) &&
            !this.singleSelection) {
            /*highlight all*/
            this.highlightAll();
        }
        else if (e.code === "Delete" || e.code === "Backspace") {
            /*Deselect highlighted items*/
            this.unselectHighlightedItems();
        }
        this.evaluateSelectedItems();
    };
    handleArrow = (direction, shiftKey) => {
        /*Get the next element*/
        let newElement;
        const activeElement = this.getActiveItem();
        newElement =
            direction === "ArrowDown"
                ? (newElement = this.getNextItem(activeElement))
                : (newElement = this.getPrevItem(activeElement));
        /*Handle*/
        if (newElement) {
            this.singleSelection &&
                !this.allowsEmpty &&
                newElement !== this.getSelectedItemsFunc()[0] &&
                this.clearSelectedItems();
            if (shiftKey && !this.singleSelection) {
                !this.activeItem.selected && this.selectItems(this.activeItem);
                !newElement.selected && this.selectItems(newElement);
            }
            this.unhighlightAll();
            this.setActiveItem(newElement);
            this.highlightItem(newElement);
            if (shiftKey && !this.singleSelection) {
                //this.selectItems(this.activeItem);
            }
            if ((this.singleSelection || (!this.singleSelection && shiftKey)) &&
                !newElement.selected &&
                !this.allowsEmpty) {
                this.selectItems(newElement);
            }
            else if (this.singleSelection) {
            }
            repositionScroll(this.main, newElement, direction);
        }
    };
    /* SELECTED */
    setSiblingSelected = async () => {
        const allItems = this.getAllItems();
        allItems.forEach((item, i) => {
            if (i === allItems.length - 1) {
                item.siblingIsSelected = false;
            }
            else {
                if (allItems[i + 1].selected) {
                    item.siblingIsSelected = true;
                }
                else {
                    item.siblingIsSelected = false;
                }
            }
        });
    };
    clearSelectedItems(ignoreHighlighted = false) {
        const actualSelectedItems = ignoreHighlighted
            ? this.el.querySelectorAll("gxg-list-box-item[selected]:not([highlighted])")
            : this.el.querySelectorAll("gxg-list-box-item[selected]");
        if (actualSelectedItems.length > 0) {
            actualSelectedItems.forEach(item => {
                this.unselectItems(item);
            });
        }
    }
    selectedItemsLength = () => {
        return this.getSelectedItemsFunc().length;
    };
    getSelectedItemsFunc() {
        const selectedItemsArray = [];
        const enabledItems = this.getAllItems();
        if (enabledItems?.length) {
            enabledItems.forEach(item => {
                item.selected && selectedItemsArray.push(item);
            });
        }
        return selectedItemsArray;
    }
    /* HIGHLIGHTED */
    highlightItem(item, doNotActivate = false) {
        if (item) {
            this.singleSelection && this.clearHighlightedItems();
            item.highlighted = true;
            !doNotActivate && (this.activeItem = item);
        }
    }
    unhighlightItem(item) {
        if (item) {
            item.highlighted = false;
        }
    }
    unhighlightAll(ignoreActiveItem = false) {
        const enabledItems = this.getEnabledItems();
        if (enabledItems?.length) {
            enabledItems.forEach(item => {
                ignoreActiveItem && item === this.activeItem
                    ? null
                    : (item.highlighted = false);
            });
            return enabledItems.length;
        }
        return 0;
    }
    toggleHighlightedItems() {
        const highlightedItems = this.getHighlightedItems();
        highlightedItems.forEach(item => {
            this.toggleItem(item);
        });
    }
    selectHighlightedItems() {
        const selectedItems = this.selectItems(this.getHighlightedItems());
        return selectedItems;
    }
    unselectHighlightedItems() {
        const length = this.unselectItems(this.getHighlightedItems());
        return length;
    }
    clearHighlightedItems() {
        const enabledItems = this.getEnabledItems();
        if (enabledItems?.length) {
            enabledItems.forEach(item => {
                item.highlighted && this.unhighlightItem(item);
            });
        }
    }
    getHighlightedItems() {
        const highlightedItemsArray = [];
        const enabledItems = this.getEnabledItems();
        if (enabledItems?.length) {
            enabledItems.forEach(item => {
                item.highlighted && highlightedItemsArray.push(item);
            });
        }
        return highlightedItemsArray;
    }
    getHighlightedItemsLength() {
        return this.getHighlightedItems().length;
    }
    highlightAll() {
        let highlightedItemsLength = 0;
        const enabledItems = this.getEnabledItems();
        if (enabledItems?.length) {
            enabledItems.forEach(item => {
                this.highlightItem(item, true);
                highlightedItemsLength++;
            });
        }
        return highlightedItemsLength;
    }
    /* INDEX */
    getItemByIndex(index) {
        const enabledItems = this.getEnabledItems();
        let itemByIndex;
        if (enabledItems?.length) {
            itemByIndex = enabledItems.find(item => item.index === index);
        }
        return itemByIndex;
    }
    getIndexByElement = (el) => {
        let index;
        const enabledItems = this.getEnabledItems();
        if (enabledItems?.length) {
            const element = enabledItems.find(item => item === el);
            element && (index = element.index);
        }
        return index;
    };
    /* PREV/NEXT */
    getNextItem(currentActive) {
        const enabledItems = this.getEnabledItems();
        const enabledActiveItemIndex = enabledItems.findIndex(enabledItem => {
            return enabledItem === currentActive;
        });
        //If is the last item, select the first one
        if (enabledActiveItemIndex === enabledItems.length - 1) {
            return enabledItems[0];
        }
        else {
            return enabledItems[enabledActiveItemIndex + 1];
        }
    }
    getPrevItem(currentActive) {
        const enabledItems = this.getEnabledItems();
        const enabledActiveItemIndex = enabledItems.findIndex(enabledItem => {
            return enabledItem === currentActive;
        });
        //If is the first item, select the last one
        if (enabledActiveItemIndex === 0) {
            return enabledItems[enabledItems.length - 1];
        }
        else {
            return enabledItems[enabledActiveItemIndex - 1];
        }
    }
    /* SELECTED */
    selectItems(items) {
        let selected = 0;
        if (items && Array.isArray(items) && items.length > 0) {
            items.forEach(item => {
                if (!item.selected && !item.disabled) {
                    (item.selected = true) && selected++;
                }
                this.activeItem !== item && this.unhighlightItem(item);
            });
        }
        else if (items && !Array.isArray(items)) {
            if (!items.selected && !items.disabled) {
                (items.selected = true) && selected++;
            }
            this.activeItem !== items && this.unhighlightItem(items);
        }
        //this.updateSelectedItems();
        return selected;
    }
    unselectItems(items) {
        let unselected = 0;
        let selectedItemsLength = this.selectedItemsLength();
        if (items &&
            Array.isArray(items) &&
            items.length > 0 &&
            selectedItemsLength > 0) {
            items.forEach(item => {
                if (item.selected && !item.disabled) {
                    if (this.allowsEmpty) {
                        item.selected = false;
                        unselected++;
                    }
                    else {
                        /*al least one item has to stay selected*/
                        if (selectedItemsLength > 1) {
                            item.selected = false;
                            unselected++;
                            selectedItemsLength--;
                        }
                    }
                }
                this.activeItem !== item && this.unhighlightItem(item);
            });
        }
        else if (items && !Array.isArray(items)) {
            if (items.selected && !items.disabled) {
                items.selected = false;
                unselected++;
            }
            this.activeItem !== items && this.unhighlightItem(items);
        }
        //unselected > 0 && this.updateSelectedItems();
        return unselected;
    }
    toggleItem(item) {
        if (item?.selected) {
            this.unselectItems(item);
        }
        else {
            this.selectItems(item);
        }
    }
    evaluateSelectedItems = () => {
        const selectedItemsArray = [];
        const selectedItemsArrayFullInfo = [];
        const selectedItems = this.getSelectedItems();
        selectedItems.then(result => {
            result.forEach(item => {
                selectedItemsArray.push(item.value);
                selectedItemsArrayFullInfo.push({
                    active: item.active,
                    selected: item.selected,
                    checked: item.checked,
                    index: item.index,
                    value: item.value
                });
            });
            const arraysDiffer = JSON.stringify(this.selectedItemsState) !==
                JSON.stringify(selectedItemsArray);
            if (arraysDiffer) {
                this.selectedItemsState = selectedItemsArray;
                this.selectedItems = [...selectedItemsArrayFullInfo];
            }
        });
    };
    updateSelectedItems = () => {
        const selectedItemsArray = [];
        const selectedItems = this.getSelectedItems();
        selectedItems.then(result => {
            result.forEach(item => {
                selectedItemsArray.push(item.value);
            });
            const arraysDiffer = JSON.stringify(this.selectedItemsState) !==
                JSON.stringify(selectedItemsArray);
            if (arraysDiffer) {
                this.selectedItemsState = selectedItemsArray;
            }
        });
    };
    /* ACTIVE */
    getActiveItem() {
        const enabledItems = this.getEnabledItems();
        return enabledItems.find(item => item.active);
    }
    setActiveItem(item) {
        if (item) {
            this.clearActiveItem(); /*Only one active item allowed at a time*/
            item.active = true;
            this.activeItem = item;
            return true;
        }
        return false;
    }
    clearActiveItem() {
        const activeItem = this.getActiveItem();
        if (activeItem) {
            activeItem.active = false;
            return true;
        }
        return false;
    }
    /* ENABLED */
    getEnabledItems() {
        const enabledItemsArray = [];
        const enabledItems = this.el.querySelectorAll("gxg-list-box-item");
        enabledItems.forEach(item => {
            !item.disabled && enabledItemsArray.push(item);
        });
        return enabledItemsArray;
    }
    /* DISABLED*/
    getDisabledItems() {
        const disabledItemsArray = [];
        const allItems = this.el.querySelectorAll("gxg-list-box-item");
        allItems.forEach(item => {
            item.disabled && disabledItemsArray.push(item);
        });
        return disabledItemsArray;
    }
    /* CHECKBOX */
    setCheckboxState(items, check = true) {
        if (items && Array.isArray(items) && items.length !== 0) {
            let changed = 0;
            items.forEach(item => {
                if (!item.checked && check) {
                    item.checked = true;
                    changed++;
                }
                else if (item.checked && !check) {
                    item.checked = false;
                    changed++;
                }
            });
            return changed;
        }
        else if (!(items && Array.isArray(items))) {
            const item = items;
            if (!item.checked && check) {
                item.checked = true;
                return 1;
            }
            else if (item.checked && !check) {
                item.checked = false;
                return 1;
            }
        }
        return 0;
    }
    /* OTHER */
    getAllItems = () => {
        const allItemsArray = [];
        const allItems = this.el.querySelectorAll("gxg-list-box-item");
        if (allItems?.length) {
            allItems.forEach(item => {
                allItemsArray.push(item);
            });
        }
        return allItemsArray;
    };
    getFirstEnabledItem() {
        return this.getEnabledItems()[0] || null;
    }
    getFirstSelectedItem() {
        const enabledItems = this.getEnabledItems();
        if (enabledItems?.length && enabledItems[0].selected) {
            return enabledItems[0];
        }
        return undefined;
    }
    selectMultipleItems(fromIndex, toIndex) {
        let comparator = toIndex;
        const selectedItems = [];
        if (fromIndex === toIndex) {
            return;
        }
        else if (fromIndex > toIndex) {
            const fromIndexCopy = fromIndex;
            fromIndex = toIndex;
            toIndex = fromIndexCopy;
            comparator = fromIndex;
        }
        for (let i = fromIndex; i <= toIndex; i++) {
            const item = this.getItemByIndex(i);
            item && selectedItems.push(item);
            if (i === comparator) {
                this.highlightItem(item);
            }
        }
        if (selectedItems?.length > 0) {
            this.selectItems(selectedItems);
        }
    }
    renderKeyboardSuggestions() {
        if (Object.keys(this.keyboardSuggestions).length) {
            const itemsArray = [];
            for (const key in this.keyboardSuggestions) {
                const listItem = (h("li", { class: "suggestions-__list-item" }, this.keyboardSuggestions[key]));
                itemsArray.push(listItem);
            }
            return (h("div", { class: "suggestions suggestions__container" }, h("ul", { class: "suggestions__list" }, itemsArray), h("gxg-button", { class: "suggestions__button", type: "secondary-icon-only", icon: "gemini-tools/close", onClick: () => (this.hideKeyboardSuggestions = true) })));
        }
    }
    /* RENDER */
    render() {
        return (h(Host, { class: {
                large: state.large,
                "has-title": !!this.theTitle,
                [formClasses["VALIDATION_INDETERMINATE_CLASS"]]: this.validationStatus === "indeterminate",
                [formClasses["VALIDATION_WARNING_CLASS"]]: this.validationStatus === "warning",
                [formClasses["VALIDATION_ERROR_CLASS"]]: this.validationStatus === "error",
                [formClasses["VALIDATION_SUCCESS_CLASS"]]: this.validationStatus === "success",
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled
            }, onKeyDown: this.handleKeyDown }, h("div", { class: { container: true, "form-element": true }, tabindex: this.disabled ? "-1" : "0", ref: el => (this.containerEl = el) }, this.theTitle ? (h("header", { class: { header: true }, ref: el => (this.header = el) }, this.theTitle)) : null, !this.disableSuggestions && !this.hideKeyboardSuggestions
            ? this.renderKeyboardSuggestions()
            : null, h("main", { class: {
                main: true
            }, style: {
                height: `calc(100% - ${this.headerHeight}px)`
            }, ref: el => (this.main = el) }, h("slot", null))), formMessageLogic(this)));
    }
    static get is() { return "gxg-list-box"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["list-box.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["list-box.css"]
        };
    }
    static get properties() {
        return {
            "theTitle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The listbox title that appears on the header"
                },
                "attribute": "the-title",
                "reflect": false
            },
            "checkboxes": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute will display a checkbox for every item"
                },
                "attribute": "checkboxes",
                "reflect": false,
                "defaultValue": "false"
            },
            "singleSelection": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute will deactivate multi-selection"
                },
                "attribute": "single-selection",
                "reflect": false,
                "defaultValue": "false"
            },
            "allowsEmpty": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute allows the list-box to not have any list-box-item selected"
                },
                "attribute": "allows-empty",
                "reflect": false,
                "defaultValue": "false"
            },
            "emitEmptySelection": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute prevents 'selectionChanged' event from being emitted if the selection is empty."
                },
                "attribute": "emit-empty-selection",
                "reflect": false,
                "defaultValue": "false"
            },
            "keyboardSuggestions": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "KeyboardSuggestions",
                    "resolved": "{ checkCheckbox: string; uncheckCheckbox: string; }",
                    "references": {
                        "KeyboardSuggestions": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/list-box/list-box.tsx",
                            "id": "src/components/list-box/list-box.tsx::KeyboardSuggestions"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An object with suggestions about the possible keyboard combinations"
                },
                "defaultValue": "{\n    checkCheckbox: \"to check a checkbox press (shift + space)\",\n    uncheckCheckbox: \"to uncheck a checkbox press (shift + ctrl + space)\"\n  }"
            },
            "disableSuggestions": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disable suggestions about keyboard combinations"
                },
                "attribute": "disable-suggestions",
                "reflect": false,
                "defaultValue": "false"
            },
            "noBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disables the border all around"
                },
                "attribute": "no-border",
                "reflect": true,
                "defaultValue": "false"
            },
            "borderTop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute adds a border to the top"
                },
                "attribute": "border-top",
                "reflect": true,
                "defaultValue": "false"
            },
            "borderEnd": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute adds a border to the end"
                },
                "attribute": "border-end",
                "reflect": true,
                "defaultValue": "false"
            },
            "borderBottom": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute adds a border to the bottom"
                },
                "attribute": "border-bottom",
                "reflect": true,
                "defaultValue": "false"
            },
            "borderStart": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute adds a border to the start"
                },
                "attribute": "border-start",
                "reflect": true,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the component disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Make the radio-buttons required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "validationMessage": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The required message if this input is required and no value is provided (optional). If this is not provided, the default browser required message will show up"
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "informationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An informative message to help the user filling the information"
                },
                "attribute": "information-message",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "selectedItems": {},
            "checkedItems": {},
            "hideKeyboardSuggestions": {},
            "headerHeight": {}
        };
    }
    static get events() {
        return [{
                "method": "selectionChanged",
                "name": "selectionChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event emits the items that are currently selected. event.detail contains the selected items as objects. Each object contains the item idex and the item value. If value was not provided, the value will be the item innerText."
                },
                "complexType": {
                    "original": "SelectionChangedEvent",
                    "resolved": "{ items: ItemsInformation[]; }",
                    "references": {
                        "SelectionChangedEvent": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/list-box/list-box.tsx",
                            "id": "src/components/list-box/list-box.tsx::SelectionChangedEvent"
                        }
                    }
                }
            }, {
                "method": "checkedChanged",
                "name": "checkedChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "getSelectedItems": {
                "complexType": {
                    "signature": "() => Promise<ItemsInformation[]>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "ItemsInformation": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/list-box/list-box.tsx",
                            "id": "src/components/list-box/list-box.tsx::ItemsInformation"
                        },
                        "HTMLGxgListBoxItemElement": {
                            "location": "global",
                            "id": "global::HTMLGxgListBoxItemElement"
                        }
                    },
                    "return": "Promise<ItemsInformation[]>"
                },
                "docs": {
                    "text": "*******************************\nMETHODS\n*******************************",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "selectedItems",
                "methodName": "selectedItemsHandler"
            }, {
                "propName": "checkedItems",
                "methodName": "checkedItemsHandler"
            }, {
                "propName": "disabled",
                "methodName": "disabledHandler"
            }, {
                "propName": "hideKeyboardSuggestions",
                "methodName": "hideKeyboardSuggestionsHandler"
            }];
    }
    static get listeners() {
        return [{
                "name": "itemLoaded",
                "method": "itemLoadedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "itemClicked",
                "method": "itemClickedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "itemSelected",
                "method": "itemSelectedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "checkboxStateChanged",
                "method": "checkboxStateChangedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=list-box.js.map
